/**
 * Detecta se o dispositivo é móvel
 */
export const isMobileDevice = (): boolean => {
  // Verificar user agent
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Padrões comuns de dispositivos móveis
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Verificar se é mobile pelo user agent
  if (mobileRegex.test(userAgent)) {
    return true;
  }
  
  // Verificar largura da tela (fallback)
  // Dispositivos móveis geralmente têm largura máxima de 768px
  if (window.innerWidth <= 768) {
    return true;
  }
  
  // Verificar se há touch support (dispositivos móveis geralmente têm)
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    // Mas verificar se não é um tablet grande ou desktop com touch
    if (window.innerWidth > 1024) {
      return false; // Provavelmente desktop com touch
    }
    return true;
  }
  
  return false;
};

/**
 * Detecta se é um tablet
 */
export const isTablet = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /ipad|android(?!.*mobile)|tablet/i.test(userAgent);
};

/**
 * Detecta se o app está rodando como PWA instalada
 * (standalone mode ou iOS standalone)
 */
export const isPWAInstalled = (): boolean => {
  // Verificar display-mode: standalone (Android/Desktop)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  
  // Verificar iOS standalone
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (iOS && (window.navigator as any).standalone === true) {
    return true;
  }
  
  return false;
};

